module.exports = __webpack_public_path__ + "img/racecourse-scottsville-turf-inner.a2bea389.svg";